export const hasAccess = (userRoles: string[] = [], allowedRoles: string[] = []): boolean =>
  allowedRoles.some(role => userRoles.includes(role));
